import i18n from '../i18n';

/** "5 минут назад" / "5 minutes ago", falling back to a date for anything older than a week. */
export function relativeTime(ms: number | null | undefined): string {
  if (!ms) return '';
  const lang = i18n.language.startsWith('en') ? 'en' : 'ru';
  const diff = (ms - Date.now()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
  const abs = Math.abs(diff);
  if (abs < 45) return lang === 'en' ? 'just now' : 'только что';
  if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
  if (abs < 7 * 86400) return rtf.format(Math.round(diff / 86400), 'day');
  return new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short', year: abs > 300 * 86400 ? 'numeric' : undefined }).format(ms);
}
